import { Heading } from '@wix/design-system';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import titleStyles from './PageTitle.scss';
import s from './AiPlanTitleLoading.scss';

export const AI_PLAN_TITLE_LOADING_KEY =
  'premium-purchase-plan.package-picker-skeleton.loader';

/**
 * Placeholder shown in the page-title slot while the AI plan copy
 * (`eclipseAiPlanCopy`) is being generated. Reuses the exact `.title`
 * typography and color as the resolved `PageTitle` heading so swapping from
 * loading to loaded state doesn't cause a layout jump - the title text is
 * static — both the title text and the trailing dots are rendered as-is.
 */
export const AiPlanTitleLoading = () => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  // Strip trailing dots: the translation value may include "..." but the
  // component renders its own dot spans (aria-hidden) to keep the ellipsis
  // accessible. Without stripping we'd end up with double "......".
  const title = t(AI_PLAN_TITLE_LOADING_KEY).replace(/\.+$/, '');

  return (
    <Heading
      className={titleStyles.title}
      size="large"
      role="status"
      aria-live="polite"
    >
      <span className={s.loadingText}>{title}</span>
      <span className={s.dots} aria-hidden="true">
        <span className={s.dot}>.</span>
        <span className={s.dot}>.</span>
        <span className={s.dot}>.</span>
      </span>
    </Heading>
  );
};
